export default {
    BENS : 'Bens',
    OBRAS : 'Obras',
    SERVICOS : 'Serviços',
    SERVICOS_ENGENHARIA : 'Serviços de Engenharia'
}
